var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        attrs: {
          data: _vm.data,
          columns: _vm.columns,
          "row-key": "id",
          loading: _vm.loading,
          pagination: _vm.pagination,
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          },
          "row-click": _vm.rowClickHandler
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c("span", [_vm._v("Список зон")]),
                _vm._v(" "),
                _c("q-space"),
                _vm._v(" "),
                _c("q-btn", {
                  attrs: {
                    color: "primary",
                    disable: _vm.loading,
                    label: "Новая зона"
                  },
                  on: { click: _vm.addZone }
                }),
                _vm._v(" "),
                _vm.rowActive
                  ? _c(
                      "div",
                      [
                        _c("q-btn", {
                          staticClass: "q-ml-sm",
                          attrs: {
                            color: "primary",
                            disable: _vm.loading,
                            label: "Показать на карте"
                          },
                          on: { click: _vm.ShowZone }
                        }),
                        _vm._v(" "),
                        _c("q-btn", {
                          staticClass: "q-ml-sm",
                          attrs: {
                            color: "primary",
                            disable: _vm.loading,
                            label: "Удалить зону"
                          },
                          on: { click: _vm.deleteZone }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("q-space")
              ]
            },
            proxy: true
          },
          {
            key: "header-cell-name",
            fn: function(props) {
              return [
                _c(
                  "q-th",
                  { attrs: { props: props } },
                  [
                    _vm._v("\n        Название\n        "),
                    _c("q-input", {
                      attrs: {
                        borderless: "",
                        dense: "",
                        debounce: "300",
                        color: "primary"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "append",
                            fn: function() {
                              return [
                                _c("q-icon", { attrs: { name: "search" } })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.filterName,
                        callback: function($$v) {
                          _vm.filterName = $$v
                        },
                        expression: "filterName"
                      }
                    })
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "header-cell-description",
            fn: function(props) {
              return [
                _c(
                  "q-th",
                  { attrs: { props: props } },
                  [
                    _vm._v("\n        Описание\n        "),
                    _c("q-input", {
                      attrs: {
                        borderless: "",
                        dense: "",
                        debounce: "300",
                        color: "primary"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "append",
                            fn: function() {
                              return [
                                _c("q-icon", { attrs: { name: "search" } })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.filterDescription,
                        callback: function($$v) {
                          _vm.filterDescription = $$v
                        },
                        expression: "filterDescription"
                      }
                    })
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("confirm-dialog", {
        ref: "confirmDialog",
        attrs: { open: _vm.confirm },
        on: {
          cancel: function($event) {
            _vm.confirm = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }